import { OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { StaticValueService } from '../../services/static-value.service';
import { OrganizationService } from '../../services/organization.service';
import { AuthService } from '../../services/auth/auth.service';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {AssociateService} from '../../../associate/shared/services/associate.service';

@Component({
  selector: 'app-mobile-filter',
  templateUrl: './mobile-filter.component.html',
  styleUrls: ['./mobile-filter.component.css']
})
export class MobileFilterComponent implements OnInit {
  // @ViewChild('gender') gender: ElementRef;
  public type: any;
  public isManager: any;
  public associateFilter= {organization: '' , country : '', gender:'', jobCategory: '', city: '' };
  public workgroupFilter= {startDate: '', endDate: '', myWorkgroup: false,
   isInactive: false, pending: false, approved: false, groupStatus:{active:true,inactive:true}}
  public listFilter= {title: '' , role :'' };
  public listAssociateFilter = {company: '' , jobCategory: '', country: '', gender: ''}
  public staticDDList = {};
  public organizations: any;
  public organizationCountries;

  constructor(
    public dialogRef: MatDialogRef<MobileFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public auth: AuthService,
    public staticService: StaticValueService,
    public organizationService: OrganizationService,
    public associateService: AssociateService,
    private _renderer: Renderer) {
      this.type = this.data.type;
      if (this.type === 'associate') {
        this.associateService.getDistinctAssociateCountries().subscribe(oCountries => {
          this.organizationCountries = oCountries;
          console.log(this.organizationCountries);
      }, error => {});
        this.associateFilter.country = this.data.country;
        this.associateFilter.organization = this.data.organization;
        this.associateFilter.jobCategory = this.data.jobCategory;
        this.associateFilter.gender = this.data.gender;
      }else if( this.type === 'workgroup'){
        this.workgroupFilter.startDate = this.data.startDate;
        this.workgroupFilter.endDate = this.data.endDate;
        this.workgroupFilter.myWorkgroup = this.data.myWorkgroup;
        this.workgroupFilter.pending = this.data.pending;
        this.workgroupFilter.isInactive = this.data.isInactive;
        this.workgroupFilter.approved = this.data.approved;
        this.workgroupFilter.groupStatus = this.data.groupStatus;
      } else if( this.type === 'company') {
        this.organizationService.getOpcoCountries().subscribe(orgCountries => {
          this.organizationCountries = Object.assign([], orgCountries);
      }, error => {});
        this.associateFilter.country = this.data.country;
        this.associateFilter.city = this.data.city;
      } else if( this.type==='List'){
        this.listFilter.title=this.data.title;
        this.listFilter.role=this.data.role;
      } else if( this.type === 'ListProfile') {
        this.listAssociateFilter.jobCategory = this.data.jobCategory;
        this.listAssociateFilter.gender = this.data.gender;
        this.listAssociateFilter.country = this.data.country;
        this.listAssociateFilter.company = this.data.company;
      }

     }

  ngOnInit() {
    // this._renderer.invokeElementMethod(this.gender.nativeElement, 'focus', []); // set focus on gender select 
    this.staticDDList = this.staticService.staticData.staticDD;
    if (this.auth.user.role === 'Admin' || this.auth.user.role === 'Super Admin' || this.auth.user.role === 'OpCo Manager' ||
     this.auth.user.role === 'HR Manager' || this.auth.user.role === 'Marcom Manager') {
          this.isManager = true;
        }
        console.log(this.isManager, this.type)
    this.organizationService.getOrganization().subscribe((data) => {
      this.organizations = data;
  }, ( error) => {
      console.log('Error getting organizations', error);
  });
  }

  applyFilter() {
    if ( this.type === 'associate' ) {
      this.dialogRef.close(this.associateFilter);
    }else if (this.type === 'workgroup') {
      this.dialogRef.close(this.workgroupFilter);
    }else if (this.type === 'company') {
      this.dialogRef.close(this.associateFilter);
    }else if (this.type === 'List') {
      this.dialogRef.close(this.listFilter);
    } else if( this.type === 'ListProfile'){
      this.dialogRef.close(this.listAssociateFilter);
    }
  }
  cancel() {
    this.dialogRef.close();
  }

}
